export function getInvitationPublicUrl(invitationId) {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  return `${origin}/invito?id=${encodeURIComponent(invitationId)}`;
}

export async function copyInvitationLink(invitationId) {
  const url = getInvitationPublicUrl(invitationId);
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(url);
    return url;
  }
  const textarea = document.createElement('textarea');
  textarea.value = url;
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  document.body.removeChild(textarea);
  return url;
}

export function downloadQrCode(canvasId, filename = 'invito-qr.png') {
  const canvas = document.getElementById(canvasId);
  if (!canvas) return;
  const link = document.createElement('a');
  link.download = filename;
  link.href = canvas.toDataURL('image/png');
  link.click();
}
